/* /assets/cb-wiyw-request.js */
/*
  Purpose:
  - Replace Klaviyo WIYW popup handling with one shared native Shopify request modal
  - Open the modal from any unavailable WIYW tile
  - Populate the 3 hidden request fields accurately:
      1. Garment request type
      2. Original design handle
      3. Original design title
  - Preserve request context across submit/reload using sessionStorage
  - Reopen the modal automatically after success or validation error
*/

(function () {
  var STORAGE_KEY = 'cb_wiyw_request_context_v1';

  var GARMENT_LABELS = {
    't-shirt': 'T-Shirt',
    hoodie: 'Hoodie',
    ls: 'Long Sleeve Tee',
    womens: "Women's Cut",
    tank: 'Tank Top'
  };

  function safeParse(json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      return null;
    }
  }

  function getStoredContext() {
    try {
      return safeParse(sessionStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return null;
    }
  }

  function setStoredContext(context) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context));
    } catch (error) {}
  }

  function clearStoredContext() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function getReadableGarmentLabel(garmentKey) {
    return GARMENT_LABELS[garmentKey] || garmentKey || 'Garment';
  }

  function getRequestHeading(root, garmentKey) {
    var defaultTitle = root.getAttribute('data-modal-default-title') || 'Request this garment';
    var garmentLabel = getReadableGarmentLabel(garmentKey);

    if (!garmentKey) return defaultTitle;
    return 'Request as a ' + garmentLabel;
  }

  function openModal(root) {
    var modal = root.querySelector('[data-cb-wiyw-modal]');
    if (!modal) return;

    modal.hidden = false;
    document.body.classList.add('cb-wiyw-modal-open');
  }

  function closeModal(root) {
    var modal = root.querySelector('[data-cb-wiyw-modal]');
    if (!modal) return;

    modal.hidden = true;
    document.body.classList.remove('cb-wiyw-modal-open');
  }

  function populateModal(root, context) {
    if (!root || !context) return;

    var modal = root.querySelector('[data-cb-wiyw-modal]');
    if (!modal) return;

    var titleEl = modal.querySelector('.cb-wiyw__modal-title');
    var garmentField = modal.querySelector('[data-cb-wiyw-field="garment"]');
    var handleField = modal.querySelector('[data-cb-wiyw-field="handle"]');
    var productTitleField = modal.querySelector('[data-cb-wiyw-field="title"]');

    if (titleEl) {
      titleEl.textContent = getRequestHeading(root, context.garment);
    }

    if (garmentField) {
      garmentField.value = getReadableGarmentLabel(context.garment);
    }

    if (handleField) {
      handleField.value = context.handle || '';
    }

    if (productTitleField) {
      productTitleField.value = context.title || '';
    }
  }

  function buildContextFromButton(button) {
    return {
      garment: button.getAttribute('data-garment') || '',
      handle: button.getAttribute('data-current-handle') || '',
      title: button.getAttribute('data-title') || ''
    };
  }

  function initializeSection(root) {
    if (!root || root.dataset.cbWiywInitialized === 'true') return;
    root.dataset.cbWiywInitialized = 'true';

    var modal = root.querySelector('[data-cb-wiyw-modal]');
    if (!modal) return;

    var form = modal.querySelector('form');
    var emailInput = modal.querySelector('input[name="contact[email]"]');
    var storedContext = getStoredContext();
    var shouldOpenOnLoad = modal.getAttribute('data-open-on-load') === 'true';

    if (storedContext) {
      populateModal(root, storedContext);
    }

    if (shouldOpenOnLoad) {
      openModal(root);

      if (modal.querySelector('.cb-wiyw__status--success')) {
        clearStoredContext();
      } else if (emailInput) {
        window.requestAnimationFrame(function () {
          emailInput.focus();
        });
      }
    }

    root.addEventListener('click', function (event) {
      var requestButton = event.target.closest('[data-cb-wiyw-request]');
      if (requestButton && root.contains(requestButton)) {
        event.preventDefault();

        var context = buildContextFromButton(requestButton);
        setStoredContext(context);
        populateModal(root, context);
        openModal(root);

        if (emailInput) {
          window.requestAnimationFrame(function () {
            emailInput.focus();
          });
        }

        return;
      }

      var closeButton = event.target.closest('[data-cb-wiyw-close]');
      if (closeButton && modal.contains(closeButton)) {
        event.preventDefault();
        closeModal(root);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (modal.hidden) return;

      closeModal(root);
    });

    if (form) {
      form.addEventListener('submit', function () {
        var currentContext = getStoredContext();
        if (currentContext) {
          populateModal(root, currentContext);
        }
      });
    }
  }

  function init() {
    var roots = document.querySelectorAll('.cb-wiyw[data-section-id]');
    if (!roots.length) return;

    roots.forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();